import { createContext, useContext, useEffect, useCallback } from 'react';

const ThemeContext = createContext(undefined);

const STORAGE_KEY = 'palcare-theme';

export function ThemeProvider({ children }) {
    // Dark mode is disabled — always use light theme.
    const theme = 'light';

    // Ensure data-theme attribute and localStorage are set to 'light' on mount.
    // Clears any stale 'dark' value left over from when the toggle existed.
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', 'light');
        try {
            localStorage.setItem(STORAGE_KEY, 'light');
        } catch {
            // silently ignore storage errors
        }
    }, []);

    // No-ops so existing consumers of useTheme() don't break
    const toggleTheme = useCallback(() => {}, []);
    const setTheme = useCallback(() => {}, []);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}

export default ThemeContext;
